var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-alert',{staticClass:"table_msg",attrs:{"type":"info"}},[_c('template',{slot:"message"},[_c('span',{staticStyle:{"margin-right":"12px"}},[_vm._v("总计: "),_c('a',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.totalCount))])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }